
import Vue from 'vue'
import ProductCarousel from '@/pages/top/components/ProductCarousel.vue'
import { TopProducts } from '@/pages/top/types'

export default Vue.extend({
  name: 'BrandsProduct',
  components: {
    ProductCarousel
  },
  props: {
    sectionItem: {
      type: Object as () => TopProducts,
      required: true
    }
  },
  data() {
    return {
      currentPage: 0,
      totalPage: 0
    }
  },
  computed: {
    showCarouselBtn(): boolean {
      return this.sectionItem.productItems.length > 4
    }
  },
  methods: {
    stringToId(value: string): string{
      return value.replace(/\W/g,'_').toLowerCase()
    },
    updatePagerHandler(value: { currentPage: number, totalPage: number}) {
      this.currentPage = value.currentPage
      this.totalPage = value.totalPage
    }
  }
})
